import React from 'react';
import { useUser } from '@v2/shared/lib/user';
import useUrlGenerator from '@v2/shared/lib/useUrlGenerator';

import AccountItem from './AccountItem';
import CartButton from '../CartButton';

/**
 * headless: apps/topmags/layouts/MainLayout/Navigation/AccountItems.
 *
 * The urls are TopMags' own account templates from its headless config -- all of them
 * `/customer?xCmd=...`, which is the legacy customer portal both stacks point at.
 */
export default function AccountItems() {
  const { user } = useUser();
  const { buildUrl } = useUrlGenerator();

  const Separator = () => <span className="px-1 text-salmon-900">|</span>;

  return (
    <ul className="flex items-center justify-center md:justify-start gap-2 mb-3">
      <li className="bg-white rounded-md p-1 px-3 flex items-center">
        {user ? (
          <>
            <AccountItem href={buildUrl('/customer?xCmd=account')}>My Account</AccountItem>
            <Separator />
            <AccountItem href={buildUrl('/customer?xCmd=logout')}>Logout</AccountItem>
          </>
        ) : (
          <>
            <AccountItem href={buildUrl('/customer?xCmd=login')}>Login</AccountItem>
            <Separator />
            <AccountItem href={buildUrl('/customer?xCmd=register&xFwd=')}>Sign Up</AccountItem>
          </>
        )}
      </li>
      <li className="bg-white rounded-md p-1 px-3 items-center hidden md:flex">
        <CartButton />
      </li>
    </ul>
  );
}
